import { Navigate, useSearchParams } from "react-router-dom";
import { CrmSettingsHubPage } from "@/pages/crm/settings/CrmSettingsHubPage";
import { CrmSettingsSectionPage } from "@/pages/crm/settings/CrmSettingsSectionPage";

const CRM_SECTION_TABS = [
  "roles",
  "permissions",
  "lead-forms",
  "schedules",
  "functions",
  "modules",
  "history",
  "usage",
] as const;

function normalizeSectionTab(raw: string | null): string {
  const t = (raw || "").toLowerCase();
  return (CRM_SECTION_TABS as readonly string[]).includes(t) ? t : "roles";
}

export function CrmSettingsPage() {
  const [searchParams] = useSearchParams();
  const view = (searchParams.get("view") || "").trim().toLowerCase();
  const tabParam = searchParams.get("tab");

  if (view === "section" || (tabParam && view !== "hub")) {
    const tab = normalizeSectionTab(tabParam);
    if (tab === "modules") {
      return <Navigate to="/crm/settings/modules" replace />;
    }
    return (
      <div className="mx-auto min-h-0 w-full max-w-7xl flex-1 overflow-y-auto px-4 py-5">
        <div className="min-w-0 flex-1 rounded-xl border border-slate-200/90 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-zinc-950">
          <CrmSettingsSectionPage tab={tab} />
        </div>
      </div>
    );
  }

  if (view === "hub" || !view) {
    return <CrmSettingsHubPage />;
  }

  return <Navigate to="/crm/settings?view=hub" replace />;
}
